import { trackEvent } from './analytics';
import { trackUmamiEvent } from './umami';

export type GameCopySource = 'game_list' | 'game_settings' | 'create_game' | 'game_visit';
export type GameCopyEvent = 'game_copy_clicked' | 'game_copy_completed' | 'game_copy_modal_shown' | 'game_copy_suggestion_shown';

/** Only categorical context; never send game keys, names, or participant details. */
export function trackGameCopy(event: GameCopyEvent, source: GameCopySource, accountType: 'guest' | 'account'): void {
  const context = event === 'game_copy_suggestion_shown' ? source
    : source === 'game_list' ? 'account_boxes'
    : source === 'game_settings' ? 'game_settings' : 'suggested_modal';
  const data = { source, context, account_type: accountType };
  try { trackEvent(event, data); } catch { /* Analytics must not block copying. */ }
  try { void Promise.resolve(trackUmamiEvent(event, data)).catch(() => {}); } catch { /* Tracker unavailable. */ }
}
